import React from "react";
import { motion } from "framer-motion";
import { GameModeEnum, isCompetitiveMode } from "interfaces/game";

interface LeaveGamePopupProps {
  gameMode: GameModeEnum;
  setShowLeaveGamePopup: (value: boolean) => void;
  leaveGame: () => void;
}

const backgroundVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.5,
    },
  },
};

const popupVariants = {
  initial: {
    top: "-100%",
    transition: {
      type: "spring",
      stiffness: 200,
      damping: 20,
    },
  },
  animate: {
    top: "50%",
    transition: {
      type: "spring",
      stiffness: 200,
      damping: 20,
    },
  },
  exit: {
    top: "-100%",
    transition: {
      type: "spring",
      stiffness: 200,
      damping: 20,
    },
  },
};

function LeaveGamePopup({
  gameMode,
  setShowLeaveGamePopup,
  leaveGame,
}: LeaveGamePopupProps) {
  return (
    <motion.div
      className="LeaveGamePopup"
      role="button"
      variants={backgroundVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      tabIndex={0}
      onClick={() => setShowLeaveGamePopup(false)}
      onKeyDown={() => setShowLeaveGamePopup(false)}
    >
      <motion.div
        className="popupContainerBorder"
        variants={popupVariants}
        initial="initial"
        animate="animate"
        exit="exit"
      />
      <motion.div
        className="popupContainer"
        variants={popupVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        role="button"
        tabIndex={0}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
        onKeyDown={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <h1 className="leaveTitle">LEAVE GAME</h1>
        {isCompetitiveMode(gameMode) && (
          <span className="leaveDescription">
            Exiting now means you&apos;re forfeiting the draft. ELO deductions
            will apply.
          </span>
        )}
        <motion.button
          className="leaveButton"
          onClick={leaveGame}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          LEAVE
        </motion.button>
      </motion.div>
    </motion.div>
  );
}

export default LeaveGamePopup;
